module.exports = __webpack_public_path__ + "img/flexo.2d9b62d3.jpeg";